import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/icons/globe.svg'
import _imports_1 from '../../../assets/img/flags/uk.webp'


const _hoisted_1 = { class: "language-dropdown" }
const _hoisted_2 = ["aria-label", "title"]
const _hoisted_3 = ["alt"]
const _hoisted_4 = {
  class: "dropdown-menu rounded-1 bg-white border-0 start-auto end-0",
  "data-popper-placement": "bottom-start"
}
const _hoisted_5 = { class: "list-style dropdown-body" }
const _hoisted_6 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "dropdown-toggle text-start text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
      type: "button",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false",
      "aria-label": _ctx.$t('header.language'),
      title: _ctx.$t('header.language')
    }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: _ctx.$t('header.language')
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "flag-item border-0 bg-transparent text-start d-flex align-items-center p-0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('en')))
          }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: _ctx.$t('header.english')
            }, null, 8, _hoisted_6),
            _createElementVNode("span", {
              class: _normalizeClass(["text-title fs-14 d-block ms-3", { 'fw-bold': _ctx.currentLocale === 'en' }])
            }, _toDisplayString(_ctx.$t("header.english")), 3)
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "flag-item border-0 bg-transparent text-start d-flex align-items-center p-0",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('km')))
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("div", {
              class: "khmer-flag-placeholder d-flex align-items-center justify-content-center bg-light rounded",
              style: {"width":"40px","height":"26px"}
            }, " 🇰🇭 ", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["text-title fs-14 d-block ms-3", { 'fw-bold': _ctx.currentLocale === 'km' }])
            }, _toDisplayString(_ctx.$t("header.khmer")), 3)
          ])
        ])
      ])
    ])
  ]))
}